<template>
  <div class="admin-layout">
    <!-- Admin Sidebar -->
    <div class="admin-sidebar" :class="{ 'collapsed': sidebarCollapsed }">
      <div class="sidebar-header">
        <a href="/" target="_blank" class="logo">
          <img :src="logoSrc" alt="StradaWebAPP" class="logo-img">
        </a>
      </div>

      <nav class="sidebar-nav" @click="handleNavClick">
        <ul class="nav-list">
          <!-- Dashboard -->
          <li class="nav-item">
            <router-link to="/admin" class="nav-link" exact-active-class="active" :title="sidebarCollapsed ? 'Dashboard' : ''">
              <i class="bi bi-speedometer2"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Dashboard</span>
            </router-link>
          </li>

          <!-- Content Section Divider - Hide in Tours Mode -->
          <li v-if="!isToursMode" class="nav-divider" v-show="!sidebarCollapsed">
            <span class="nav-section-title">
              {{ isMagazineMode ? 'MAGAZINE ΠΕΡΙΕΧΟΜΕΝΟ' : 
                 isMagazineMode ? 'MAGAZINE ΠΕΡΙΕΧΟΜΕΝΟ' : 'ΠΕΡΙΕΧΟΜΕΝΟ' }}
            </span>
          </li>

          <!-- Posts/Blog - Only in Blog/Magazine Mode, Hide in Tours Mode -->
          <li v-if="(isMagazineMode || isMagazineMode) && !isToursMode" class="nav-item">
            <router-link to="/admin/posts" class="nav-link" active-class="active" :title="sidebarCollapsed ? (isMagazineMode ? 'Άρθρα Magazine' : 'Άρθρα') : ''">
              <i class="bi bi-file-text"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">{{ isMagazineMode ? 'Άρθρα Magazine' : 'Άρθρα' }}</span>
            </router-link>
          </li>

          <!-- Post Categories - Only in Blog/Magazine Mode, Hide in Tours Mode -->
          <li v-if="(isMagazineMode || isMagazineMode) && !isToursMode" class="nav-item nav-sub-item">
            <router-link to="/admin/post-categories" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Κατηγορίες Άρθρων' : ''">
              <i class="bi bi-bookmark"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Κατηγορίες Άρθρων</span>
            </router-link>
          </li>

          <!-- Post Templates - Only in Blog/Magazine Mode, Hide in Tours Mode -->
          <li v-if="(isMagazineMode || isMagazineMode) && !isToursMode" class="nav-item nav-sub-item">
            <router-link to="/admin/post-templates" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Templates' : ''">
              <i class="bi bi-layout-text-window-reverse"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Templates</span>
            </router-link>
          </li>

          <!-- Pages - Visible in all modes -->
          <li class="nav-item">
            <router-link to="/admin/pages" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Σελίδες' : ''">
              <i class="bi bi-file-earmark-text"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Σελίδες</span>
            </router-link>
          </li>

          <!-- E-shop Section - Only in E-shop Mode, Hide in Tours Mode -->
          <template v-if="isEshopMode && !isToursMode">
            <!-- Divider -->
            <li class="nav-divider" v-if="!sidebarCollapsed">
              <span class="nav-section-title">ΠΡΟΪΟΝΤΑ & ΠΑΡΑΓΓΕΛΙΕΣ</span>
            </li>

            <!-- Products -->
            <li class="nav-item">
              <router-link to="/admin/shop" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Προϊόντα' : ''">
                <i class="bi bi-box"></i>
                <span v-if="!sidebarCollapsed" class="nav-text">Προϊόντα</span>
              </router-link>
            </li>

            <!-- Product Categories -->
            <li class="nav-item nav-sub-item">
              <router-link to="/admin/categories" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Κατηγορίες Προϊόντων' : ''">
                <i class="bi bi-tags"></i>
                <span v-if="!sidebarCollapsed" class="nav-text">Κατηγορίες Προϊόντων</span>
              </router-link>
            </li>

            <!-- Brands -->
            <li class="nav-item nav-sub-item">
              <router-link to="/admin/brands" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Brands' : ''">
                <i class="bi bi-award"></i>
                <span v-if="!sidebarCollapsed" class="nav-text">Brands</span>
              </router-link>
            </li>

            <!-- Product Addons -->
            <li class="nav-item nav-sub-item">
              <router-link to="/admin/product-addons" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Χαρακτηριστικά Προϊόντων' : ''">
                <i class="bi bi-puzzle"></i>
                <span v-if="!sidebarCollapsed" class="nav-text">Χαρακτηριστικά Προϊόντων</span>
              </router-link>
            </li>

            <!-- Orders/Bookings -->
            <li class="nav-item">
              <router-link to="/admin/bookings" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Παραγγελίες' : ''">
                <i class="bi bi-cart-check"></i>
                <span v-if="!sidebarCollapsed" class="nav-text">Παραγγελίες</span>
              </router-link>
            </li>
          </template>

          <!-- Tours Section - Only in Tours Mode -->
          <template v-if="isToursMode">
            <!-- Tours Section Divider -->
            <li class="nav-divider" v-if="!sidebarCollapsed">
              <span class="nav-section-title">ΔΙΑΧΕΙΡΙΣΗ ΕΚΔΡΟΜΩΝ</span>
            </li>

            <!-- Tours -->
            <li class="nav-item">
              <router-link to="/admin/tours" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Εκδρομές' : ''">
                <i class="bi bi-airplane"></i>
                <span v-if="!sidebarCollapsed" class="nav-text">Εκδρομές</span>
              </router-link>
            </li>

            <!-- Tour Bookings -->
            <li class="nav-item nav-sub-item">
              <router-link to="/admin/tour-bookings" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Κρατήσεις Εκδρομών' : ''">
                <i class="bi bi-calendar-check"></i>
                <span v-if="!sidebarCollapsed" class="nav-text">Κρατήσεις Εκδρομών</span>
              </router-link>
            </li>

            <!-- Tour Seats Management -->
            <li class="nav-item nav-sub-item">
              <router-link to="/admin/tour-seats" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Διαχείριση Θέσεων' : ''">
                <i class="bi bi-bus-front"></i>
                <span v-if="!sidebarCollapsed" class="nav-text">Διαχείριση Θέσεων</span>
              </router-link>
            </li>

            <!-- Tour Categories -->
            <li class="nav-item nav-sub-item">
              <router-link to="/admin/tour-categories" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Κατηγορίες Εκδρομών' : ''">
                <i class="bi bi-tags"></i>
                <span v-if="!sidebarCollapsed" class="nav-text">Κατηγορίες Εκδρομών</span>
              </router-link>
            </li>

            <!-- Tour Destinations -->
            <li class="nav-item nav-sub-item">
              <router-link to="/admin/tour-destinations" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Προορισμοί Εκδρομών' : ''">
                <i class="bi bi-geo-alt"></i>
                <span v-if="!sidebarCollapsed" class="nav-text">Προορισμοί Εκδρομών</span>
              </router-link>
            </li>
          </template>

          <!-- Restaurant Section - Only in Restaurant Mode -->
          <template v-if="isRestaurantMode">
            <!-- Restaurant menu dropdown toggle (expanded sidebar) -->
            <li v-if="!sidebarCollapsed" class="nav-item nav-group">
              <button
                type="button"
                class="nav-link nav-group-toggle"
                :class="{ open: restaurantMenuNavOpen }"
                @click="restaurantMenuNavOpen = !restaurantMenuNavOpen"
              >
                <i class="bi bi-book-half"></i>
                <span class="nav-text">Διαχείριση Μενού</span>
                <i class="bi nav-chevron" :class="restaurantMenuNavOpen ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
              </button>
            </li>

            <li v-else class="nav-divider">
              <span class="nav-section-title">ΜΕΝΟΥ</span>
            </li>

            <template v-if="restaurantMenuNavOpen || sidebarCollapsed">
              <!-- Menu Items (Products) -->
              <li class="nav-item" :class="{ 'nav-sub-item': !sidebarCollapsed }">
                <router-link to="/admin/shop" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Πιάτα Μενού' : ''">
                  <i class="bi bi-egg-fried"></i>
                  <span v-if="!sidebarCollapsed" class="nav-text">Πιάτα Μενού</span>
                </router-link>
              </li>

              <!-- Menu Categories -->
              <li class="nav-item nav-sub-item">
                <router-link to="/admin/categories" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Κατηγορίες Μενού' : ''">
                  <i class="bi bi-tags"></i>
                  <span v-if="!sidebarCollapsed" class="nav-text">Κατηγορίες Μενού</span>
                </router-link>
              </li>

              <!-- Restaurant Menu Pages -->
              <li class="nav-item nav-sub-item">
                <router-link to="/admin/settings/restaurant-menus" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Σελίδες Μενού' : ''">
                  <i class="bi bi-layout-text-window"></i>
                  <span v-if="!sidebarCollapsed" class="nav-text">Σελίδες Μενού</span>
                </router-link>
              </li>

              <!-- Brands -->
              <li class="nav-item nav-sub-item">
                <router-link to="/admin/brands" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Ετικέτες' : ''">
                  <i class="bi bi-award"></i>
                  <span v-if="!sidebarCollapsed" class="nav-text">Ετικέτες</span>
                </router-link>
              </li>

              <!-- Orders -->
              <li class="nav-item" :class="{ 'nav-sub-item': !sidebarCollapsed }">
                <router-link to="/admin/bookings" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Παραγγελίες' : ''">
                  <i class="bi bi-receipt"></i>
                  <span v-if="!sidebarCollapsed" class="nav-text">Παραγγελίες</span>
                </router-link>
              </li>

              <!-- Menu guide -->
              <li class="nav-item nav-sub-item nav-guide-item">
                <router-link to="/admin/menu-guide" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Οδηγίες Μενού' : ''">
                  <i class="bi bi-journal-text"></i>
                  <span v-if="!sidebarCollapsed" class="nav-text">Οδηγίες Μενού</span>
                </router-link>
              </li>
            </template>
          </template>

          <!-- Divider -->
          <li class="nav-divider" v-if="!sidebarCollapsed">
            <span class="nav-section-title">ΔΙΑΧΕΙΡΙΣΗ</span>
          </li>

          <!-- Users -->
          <li class="nav-item">
            <router-link to="/admin/users" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Χρήστες' : ''">
              <i class="bi bi-people"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Χρήστες</span>
            </router-link>
          </li>

          <!-- Home Builder -->
          <li class="nav-item">
            <router-link to="/admin/home-builder" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Home Builder' : ''">
              <i class="bi bi-house-gear"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Home Builder</span>
            </router-link>
          </li>

          <!-- Media Library -->
          <li class="nav-item">
            <router-link to="/admin/media" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Διαχείριση Media' : ''">
              <i class="bi bi-images"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Media Library</span>
            </router-link>
          </li>

          <!-- Divider -->
          <li class="nav-divider" v-if="!sidebarCollapsed">
            <span class="nav-section-title">ΡΥΘΜΙΣΕΙΣ & ΕΠΙΚΟΙΝΩΝΙΑ</span>
          </li>

          <!-- Settings -->
          <li class="nav-item">
            <router-link to="/admin/settings/content" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Ρυθμίσεις' : ''">
              <i class="bi bi-gear"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Ρυθμίσεις</span>
            </router-link>
          </li>

          <!-- Notifications -->
          <li class="nav-item nav-sub-item">
            <router-link to="/admin/notifications" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Ειδοποιήσεις' : ''">
              <i class="bi bi-bell"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Ειδοποιήσεις</span>
            </router-link>
          </li>

          <!-- Emails -->
          <li class="nav-item nav-sub-item">
            <router-link to="/admin/emails" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Email Client' : ''">
              <i class="bi bi-envelope"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Email Client</span>
            </router-link>
          </li>

          <!-- Reviews -->
          <li class="nav-item nav-sub-item">
            <router-link to="/admin/reviews" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Κριτικές' : ''">
              <i class="bi bi-star-fill"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Κριτικές</span>
            </router-link>
          </li>

          <!-- Tutorial -->
          <li class="nav-item">
            <router-link to="/admin/tutorial" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Οδηγίες Χρήσης' : ''">
              <i class="bi bi-book"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Οδηγίες Χρήσης</span>
            </router-link>
          </li>

          <!-- Analytics -->
          <li class="nav-item">
            <router-link to="/admin/analytics" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Analytics & Στατιστικά' : ''">
              <i class="bi bi-graph-up"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Analytics</span>
            </router-link>
          </li>

          <!-- Database Management -->
          <li class="nav-item">
            <router-link to="/admin/database" class="nav-link" active-class="active" :title="sidebarCollapsed ? 'Διαχείριση Βάσης' : ''">
              <i class="bi bi-database"></i>
              <span v-if="!sidebarCollapsed" class="nav-text">Βάση Δεδομένων</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Main Content Area -->
    <div class="admin-main" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
      <!-- Top Header -->
      <header class="admin-header">
        <div class="header-wrapper">
          <div class="header-content">
            <div class="header-left">
              <!-- Sidebar Toggle (Works on all devices) -->
              <button class="sidebar-toggle-btn" @click="toggleSidebar" :class="{ 'active': !sidebarCollapsed }">
                <i class="bi bi-list"></i>
              </button>
              <h1 class="page-title">{{ pageTitle }}</h1>
              <nav class="breadcrumb">
                <ol class="breadcrumb-list">
                  <li><router-link to="/admin">Admin</router-link></li>
                  <li v-if="breadcrumbs.length > 0" v-for="(crumb, index) in breadcrumbs" :key="index">
                    <router-link v-if="crumb.to" :to="crumb.to">{{ crumb.text }}</router-link>
                    <span v-else>{{ crumb.text }}</span>
                  </li>
                </ol>
              </nav>
            </div>
            
            <div class="header-right">
              <!-- Notifications -->
              <div class="header-item notification-dropdown" ref="notificationMenuRef">
                <button class="header-btn" @click.stop="toggleNotifications" type="button">
                  <i class="bi bi-bell"></i>
                  <span v-if="unreadNotifications > 0" class="notification-badge">{{ unreadNotifications }}</span>
                </button>
              </div>

              <!-- Quick Actions -->
              <div class="header-item">
                <router-link 
                  :to="isToursMode ? '/admin/tours' : (isRestaurantMode ? '/admin/shop' : (isEshopMode ? '/admin/shop' : '/admin/posts'))" 
                  class="header-btn" 
                  :title="isToursMode ? 'Νέα Εκδρομή' : (isRestaurantMode ? 'Νέο Πιάτο' : (isEshopMode ? 'Νέο Προϊόν' : (isMagazineMode ? 'Νέο Άρθρο Magazine' : 'Νέο Άρθρο Blog')))"
                >
                  <i class="bi bi-plus-circle"></i>
                </router-link>
              </div>

              <!-- User Menu -->
              <div class="header-item user-dropdown" ref="userMenuRef" style="position: relative;">
                <button 
                  class="header-btn user-menu-btn" 
                  @click.stop="toggleUserMenu"
                  type="button"
                >
                  <i class="bi bi-person-circle"></i>
                  <span class="user-name">{{ user?.name || 'Admin' }}</span>
                  <i class="bi bi-chevron-down"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      <!-- Page Content -->
      <main class="admin-content">
        <router-view />
      </main>
    </div>

    <!-- Overlay for mobile -->
    <div 
      v-if="!sidebarCollapsed && isMobile" 
      class="sidebar-overlay" 
      @click="toggleSidebar"
    ></div>

    <!-- User Dropdown - Teleported to body to avoid z-index issues -->
    <Teleport to="body">
      <div v-if="showUserMenu" 
           :style="dropdownPosition" 
           class="user-dropdown-portal"
           @click.stop>
        <div style="
          background: white;
          border: 1px solid #ddd;
          border-radius: 8px;
          padding: 16px;
          min-width: 220px;
          box-shadow: 0 8px 25px rgba(0,0,0,0.15);
        ">
          <div style="padding: 10px 0; border-bottom: 1px solid #eee; margin-bottom: 10px;">
            <div style="font-weight: 600; color: #333;">{{ user?.name || 'Admin' }}</div>
            <div style="font-size: 0.85rem; color: #666;">Διαχειριστής</div>
          </div>
          <div>
            <router-link to="/admin/settings" 
                        @click="showUserMenu = false"
                        style="display: flex; align-items: center; gap: 8px; padding: 8px 0; color: #333; text-decoration: none;">
              <i class="bi bi-gear"></i>
              Ρυθμίσεις
            </router-link>
            <router-link
              v-if="isRestaurantMode"
              to="/admin/menu-guide"
              @click="showUserMenu = false"
              style="display: flex; align-items: center; gap: 8px; padding: 8px 0; color: #333; text-decoration: none;"
            >
              <i class="bi bi-journal-text"></i>
              Οδηγίες Μενού
            </router-link>
            <button @click="viewProfile" 
                   style="display: flex; align-items: center; gap: 8px; padding: 8px 0; background: none; border: none; color: #333; cursor: pointer; width: 100%; text-align: left;">
              <i class="bi bi-person"></i>
              Προφίλ
            </button>
            <hr style="margin: 10px 0; border: none; border-top: 1px solid #eee;">
            <button @click="logout" 
                   style="display: flex; align-items: center; gap: 8px; padding: 8px 0; background: none; border: none; color: #dc3545; cursor: pointer; width: 100%; text-align: left;">
              <i class="bi bi-box-arrow-right"></i>
              Αποσύνδεση
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- Notifications Dropdown - Teleported to body to avoid z-index issues -->
    <Teleport to="body">
      <div v-if="showNotifications" 
           :style="notificationDropdownPosition" 
           class="notifications-dropdown-portal"
           @click.stop>
        <div style="
          background: white;
          border: 1px solid #ddd;
          border-radius: 8px;
          min-width: 300px;
          max-width: 350px;
          box-shadow: 0 8px 25px rgba(0,0,0,0.15);
        ">
          <div style="
            padding: 12px 16px;
            background: #f8f9fa;
            border-bottom: 1px solid #dee2e6;
            font-weight: 600;
            color: #495057;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 8px 8px 0 0;
          ">
            <strong>Ειδοποιήσεις</strong>
            <span style="
              background: #FF6B6B;
              color: white;
              font-size: 0.7rem;
              padding: 0.2rem 0.5rem;
              border-radius: 10px;
              min-width: 18px;
              text-align: center;
            ">{{ unreadNotifications }}</span>
          </div>
          
          <!-- Notification Items -->
          <div style="max-height: 400px; overflow-y: auto;">
            <div v-if="notifications.length === 0" style="padding: 20px; text-align: center; color: #666;">
              Δεν υπάρχουν ειδοποιήσεις
            </div>
            <div v-for="notification in notifications" :key="notification.id" 
                 @click="viewAllNotifications"
                 class="notification-item">
              <i :class="notification.icon" :style="{ color: notification.color, fontSize: '1.2rem' }"></i>
              <div style="flex: 1;">
                <div style="font-weight: 500; color: #333; margin-bottom: 2px;">{{ notification.title }}</div>
                <div style="font-size: 0.8rem; color: #666;">{{ notification.time }}</div>
              </div>
              <i class="bi bi-chevron-right" style="color: #ccc; font-size: 0.8rem;"></i>
            </div>
          </div>
          
          <div @click="viewAllNotifications" class="view-all-notifications">
            <small style="color: #007bff; font-weight: 500;">
              <i class="bi bi-eye" style="margin-right: .25rem;"></i>
              Δείτε όλες τις ειδοποιήσεις
            </small>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useSiteStyle } from '@/composables/useSiteStyle'
import { settingsService } from '@/services/api'
import { getLogoUrl } from '@/config/env'
import { API_BASE_URL } from '@/utils/config'
import { authFetch } from '@/utils/authFetch'

// Types
interface Notification {
  id: number
  type: string
  title: string
  message: string
  time: string
  icon: string
  color: string
  read: boolean
}

// Stores and Composables
const userStore = useUserStore()
const { siteStyle, isMagazineMode, isEshopMode, isToursMode, isRestaurantMode } = useSiteStyle()
const router = useRouter()
const route = useRoute()

// State
const sidebarCollapsed = ref(false)
const restaurantMenuNavOpen = ref(true)
const showUserMenu = ref(false)
const showNotifications = ref(false)
const isMobile = ref(false)
const unreadNotifications = ref(0) // Start with 0, will load from API
const notifications = ref<Notification[]>([]) // Store notifications
const isTogglingUserMenu = ref(false)
const userMenuRef = ref<HTMLElement | null>(null)
const notificationMenuRef = ref<HTMLElement | null>(null)
const logoUrl = ref('logo.png') // Default logo
let notificationInterval: number | null = null // Interval for polling notifications

// Computed
const user = computed(() => userStore.user)

// Logo source computed - using dynamic logo from settings or fallback
const logoSrc = computed(() => {
  if (logoUrl.value && logoUrl.value !== 'logo.png') {
    return `/backend/uploads/logos/${logoUrl.value}`
  }
  return `/backend/uploads/logos/logo.png` // Fallback
})

const dropdownPosition = computed(() => {
  if (!userMenuRef.value) return { display: 'none' }
  
  const rect = userMenuRef.value.getBoundingClientRect()
  return {
    position: 'fixed' as const,
    top: rect.bottom + 5 + 'px',
    right: window.innerWidth - rect.right + 'px',
    zIndex: 99999
  }
})

const notificationDropdownPosition = computed(() => {
  if (!notificationMenuRef.value) return { display: 'none' }
  
  const rect = notificationMenuRef.value.getBoundingClientRect()
  return {
    position: 'fixed' as const,
    top: rect.bottom + 5 + 'px',
    right: window.innerWidth - rect.right + 'px',
    zIndex: 99999
  }
})

const pageTitle = computed(() => {
  const routeMap: { [key: string]: string } = {
    '/admin': 'Dashboard',
    '/admin/products': 'Διαχείριση Προϊόντων',
    '/admin/shop': 'Διαχείριση Προϊόντων',
    '/admin/categories': 'Διαχείριση Κατηγοριών',
    '/admin/brands': 'Διαχείριση Brands',
    '/admin/product-addons': 'Χαρακτηριστικά Προϊόντων',
    '/admin/bookings': 'Διαχείριση Παραγγελιών',
    '/admin/tours': 'Διαχείριση Εκδρομών',
    '/admin/tour-bookings': 'Κρατήσεις Εκδρομών',
    '/admin/tour-seats': 'Διαχείριση Θέσεων',
    '/admin/tour-categories': 'Κατηγορίες Εκδρομών',
    '/admin/tour-destinations': 'Προορισμοί Εκδρομών',
    '/admin/users': 'Διαχείριση Χρηστών',
    '/admin/notifications': 'Ειδοποιήσεις',
    '/admin/emails': 'Email Client',
    '/admin/reviews': 'Διαχείριση Κριτικών',
    '/admin/media': 'Media Library',
    '/admin/settings': 'Ρυθμίσεις Συστήματος',
    '/admin/tutorial': 'Οδηγίες Χρήσης',
    '/admin/menu-guide': 'Οδηγίες Μενού',
    '/admin/analytics': 'Analytics & Στατιστικά',
    '/admin/database': 'Διαχείριση Βάσης Δεδομένων'
  }
  return routeMap[route.path] || 'Admin Panel'
})

const breadcrumbs = computed(() => {
  const path = route.path
  const crumbs: Array<{ text: string; to?: string }> = []
  
  if (path.includes('/shop')) {
    crumbs.push({ text: 'Προϊόντα', to: '/admin/shop' })
  } else if (path.includes('/products')) {
    crumbs.push({ text: 'Προϊόντα', to: '/admin/shop' })
  } else if (path.includes('/categories')) {
    crumbs.push({ text: 'Κατηγορίες', to: '/admin/categories' })
  } else if (path.includes('/brands')) {
    crumbs.push({ text: 'Brands', to: '/admin/brands' })
  } else if (path.includes('/product-addons')) {
    crumbs.push({ text: 'Χαρακτηριστικά Προϊόντων', to: '/admin/product-addons' })
  } else if (path.includes('/posts')) {
    crumbs.push({ text: 'Άρθρα', to: '/admin/posts' })
  } else if (path.includes('/tour-bookings')) {
    crumbs.push({ text: 'Κρατήσεις Εκδρομών', to: '/admin/tour-bookings' })
  } else if (path.includes('/tours')) {
    crumbs.push({ text: 'Εκδρομές', to: '/admin/tours' })
  } else if (path.includes('/users')) {
    crumbs.push({ text: 'Χρήστες', to: '/admin/users' })
  } else if (path.includes('/notifications')) {
    crumbs.push({ text: 'Ειδοποιήσεις', to: '/admin/notifications' })
  } else if (path.includes('/emails')) {
    crumbs.push({ text: 'Email Client', to: '/admin/emails' })
  } else if (path.includes('/reviews')) {
    crumbs.push({ text: 'Κριτικές', to: '/admin/reviews' })
  } else if (path.includes('/media')) {
    crumbs.push({ text: 'Media Library', to: '/admin/media' })
  } else if (path.includes('/restaurant-menus')) {
    crumbs.push({ text: 'Ρυθμίσεις', to: '/admin/settings/content' })
    crumbs.push({ text: 'Σελίδες Μενού', to: '/admin/settings/restaurant-menus' })
  } else if (path.includes('/settings')) {
    crumbs.push({ text: 'Ρυθμίσεις', to: '/admin/settings/content' })
    
    if (path.includes('/content')) {
      crumbs.push({ text: 'Κείμενα', to: '/admin/settings/content' })
    } else if (path.includes('/gallery')) {
      crumbs.push({ text: 'Gallery', to: '/admin/settings/gallery' })
    } else if (path.includes('/layout')) {
      crumbs.push({ text: 'Layout', to: '/admin/settings/layout' })
    } else if (path.includes('/sidebar-widgets')) {
      crumbs.push({ text: 'Sidebar Widgets', to: '/admin/settings/sidebar-widgets' })
    } else if (path.includes('/system')) {
      crumbs.push({ text: 'Σύστημα', to: '/admin/settings/system' })
    }
  } else if (path.includes('/menu-guide')) {
    crumbs.push({ text: 'Οδηγίες Μενού', to: '/admin/menu-guide' })
  } else if (path.includes('/tutorial')) {
    crumbs.push({ text: 'Οδηγίες Χρήσης', to: '/admin/tutorial' })
  } else if (path.includes('/analytics')) {
    crumbs.push({ text: 'Analytics & Στατιστικά', to: '/admin/analytics' })
  } else if (path.includes('/database')) {
    crumbs.push({ text: 'Διαχείριση Βάσης Δεδομένων', to: '/admin/database' })
  }
  
  return crumbs
})

const restaurantMenuRoutePattern = /\/admin\/(shop|categories|bookings|brands|menu-guide|settings\/restaurant-menus)/

watch(
  () => route.path,
  (path) => {
    if (isRestaurantMode.value && restaurantMenuRoutePattern.test(path)) {
      restaurantMenuNavOpen.value = true
    }
  },
  { immediate: true }
)

// Methods
const toggleSidebar = () => {
  sidebarCollapsed.value = !sidebarCollapsed.value
  // Only save state on desktop
  if (window.innerWidth > 768) {
    localStorage.setItem('adminSidebarCollapsed', sidebarCollapsed.value.toString())
  }
}

// Close sidebar on mobile when a nav link is clicked
const handleNavClick = (event: MouseEvent) => {
  if (!isMobile.value) return
  const target = event.target as HTMLElement
  if (target.closest('a')) {
    sidebarCollapsed.value = true
  }
}

const toggleUserMenu = () => {
  isTogglingUserMenu.value = true
  showUserMenu.value = !showUserMenu.value
  showNotifications.value = false
  
  // Reset flag after a longer delay to ensure the click event has fully processed
  setTimeout(() => {
    isTogglingUserMenu.value = false
  }, 200)
}

const toggleNotifications = () => {
  showNotifications.value = !showNotifications.value
  showUserMenu.value = false
  
  // Load notifications when opening the dropdown
  if (showNotifications.value) {
    loadNotifications()
  }
}

const loadNotifications = async () => {
  // Initialize empty notifications
  notifications.value = []
  unreadNotifications.value = 0
  
  // Skip API call if no auth token
  if (!userStore.authToken) {
    return
  }
  
  try {
    // Request only 10 notifications for the bell icon
    const response = await authFetch(`${API_BASE_URL}/notifications.php?action=get-admin-notifications&limit=10`, {
      headers: {
        'Authorization': `Bearer ${userStore.authToken}`
      }
    })
    
    if (!response.ok) {
      return // Skip on error, keep empty notifications
    }
    
    const data = await response.json()
    
    if (data.success && data.notifications) {
      notifications.value = data.notifications
      unreadNotifications.value = notifications.value.filter(n => !n.read).length
    }
  } catch (error) {
    // Keep notifications empty on error
  }
}

const viewProfile = () => {
  showUserMenu.value = false
  // Navigate to profile page or open profile modal
  router.push('/admin/profile')
}

const logout = async () => {
  try {
    await userStore.logout()
    router.push('/login')
  } catch (error) {
    // Logout error - silently handle
  }
}

const handleNotificationClick = (notification: Notification) => {
  
  // Navigate based on notification type
  switch (notification.type) {
    case 'email':
      router.push('/admin/emails')
      break
    case 'order':
      router.push('/admin/bookings')
      break
    case 'booking':
      router.push('/admin/tour-bookings')
      break
    case 'user':
      router.push('/admin/users')
      break
    case 'stock':
      router.push('/admin/shop')
      break
    default:
      // For unknown types, go to dashboard
      router.push('/admin')
  }
  
  // Close notifications dropdown
  showNotifications.value = false
}

const viewAllNotifications = () => {
  showNotifications.value = false
  router.push('/admin/notifications')
}

const handleResize = () => {
  isMobile.value = window.innerWidth < 768
  if (isMobile.value) {
    sidebarCollapsed.value = true
  }
}

// Touch/Swipe handling for mobile
let touchStartX = 0
let touchStartY = 0

const handleTouchStart = (event: TouchEvent) => {
  if (!isMobile.value) return
  touchStartX = event.touches[0].clientX
  touchStartY = event.touches[0].clientY
}

const handleTouchMove = (event: TouchEvent) => {
  if (!isMobile.value) return

  const touchX = event.touches[0].clientX
  const touchY = event.touches[0].clientY
  const deltaX = touchX - touchStartX
  const deltaY = touchY - touchStartY

  // Vertical scroll inside sidebar / page — never treat as horizontal swipe
  if (Math.abs(deltaY) >= Math.abs(deltaX)) return

  // Swipe right from left edge to open
  if (touchStartX < 24 && deltaX > 60 && sidebarCollapsed.value) {
    sidebarCollapsed.value = false
    event.preventDefault()
    return
  }

  // Clear horizontal swipe left to close (must dominate vertical)
  if (
    deltaX < -70 &&
    Math.abs(deltaX) > Math.abs(deltaY) * 2.5 &&
    !sidebarCollapsed.value
  ) {
    sidebarCollapsed.value = true
    event.preventDefault()
  }
}

const handleClickOutside = (event: Event) => {
  const target = event.target as HTMLElement
  
  // Don't close if we're currently toggling
  if (isTogglingUserMenu.value) {
    return
  }
  
  // Close user menu if clicking outside
  if (userMenuRef.value && !userMenuRef.value.contains(target)) {
    showUserMenu.value = false
  }
  
  // Close notifications if clicking outside
  if (notificationMenuRef.value && !notificationMenuRef.value.contains(target)) {
    showNotifications.value = false
  }
}

// Lifecycle
onMounted(() => {
  // Mobile initialization
  const handleScreenChange = () => {
    if (window.innerWidth <= 768) {
      // On mobile, start with sidebar collapsed
      sidebarCollapsed.value = true
    } else {
      // On desktop, restore saved state
      const saved = localStorage.getItem('adminSidebarCollapsed')
      if (saved !== null) {
        sidebarCollapsed.value = saved === 'true'
      }
    }
  }
  
  // Initial screen check
  handleScreenChange()
  
  // Listen for screen size changes
  window.addEventListener('resize', handleScreenChange)
  window.addEventListener('resize', handleResize)
  document.addEventListener('click', handleClickOutside)
  
  // Touch events for mobile swipe gestures
  document.addEventListener('touchstart', handleTouchStart, { passive: false })
  document.addEventListener('touchmove', handleTouchMove, { passive: false })
  
  // Listen for notification updates from AdminNotifications page
  window.addEventListener('notifications-updated', loadNotifications)
  
  // Load logo from settings once on mount
  loadLogo()
  
  // Load initial notifications
  loadNotifications()
  
  // Poll for new notifications every 30 seconds
  notificationInterval = window.setInterval(() => {
    loadNotifications()
  }, 30000) // 30 seconds
})

// Load logo from settings
const loadLogo = async () => {
  try {
    const response = await settingsService.getSettings()
    if (response.success && response.settings && response.settings.logo_url) {
      logoUrl.value = response.settings.logo_url
    }
  } catch (error) {
    // Error loading logo - use default
  }
}

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
  document.removeEventListener('click', handleClickOutside)
  document.removeEventListener('touchstart', handleTouchStart)
  document.removeEventListener('touchmove', handleTouchMove)
  window.removeEventListener('notifications-updated', loadNotifications)
  
  // Clear notification polling interval
  if (notificationInterval) {
    clearInterval(notificationInterval)
    notificationInterval = null
  }
})
</script>

<style scoped>
/* ── Layout ────────────────────────────────────────────────────────────── */
.admin-layout {
  --admin-header-h: 68px;
  --admin-header-border: 2px;
  --admin-header-total: calc(var(--admin-header-h) + var(--admin-header-border));
  display: flex;
  height: 100vh;
  background: #f8fafc;
  overflow: hidden;
}

/* ── Sidebar ────────────────────────────────────────────────────────────── */
.admin-sidebar {
  width: 260px;
  background: #0f172a;
  color: #94a3b8;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  z-index: 1000;
  transition: width .28s cubic-bezier(.4,0,.2,1);
  box-shadow: 2px 0 20px rgba(0,0,0,.25);
  overflow: hidden;
  overflow-x: hidden;
  overscroll-behavior: none;
  touch-action: pan-y;
}

.admin-sidebar.collapsed { width: 72px; }

/* Header / Logo */
.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem 1rem;
  min-height: 72px;
  border-bottom: 1px solid rgba(255,255,255,.07);
  background: rgba(255,255,255,.04);
  flex-shrink: 0;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.logo-img {
  width: 100px;
  height: 40px;
  object-fit: contain;
  flex-shrink: 0;
}

/* Nav */
.sidebar-nav {
  flex: 1;
  padding: .75rem 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  overscroll-behavior-x: none;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-y;
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,255,.08) transparent;
}

.sidebar-nav::-webkit-scrollbar { width: 3px; }
.sidebar-nav::-webkit-scrollbar-track { background: transparent; }
.sidebar-nav::-webkit-scrollbar-thumb { background: rgba(255,255,255,.1); border-radius: 2px; }

.nav-list { list-style: none; padding: 0; margin: 0; }

.nav-item { margin-bottom: .15rem; }

.nav-link {
  display: flex;
  align-items: center;
  gap: .75rem;
  padding: .7rem 1.25rem;
  color: #94a3b8;
  text-decoration: none;
  border-radius: 8px;
  margin: 0 .6rem;
  font-size: .9rem;
  font-weight: 500;
  transition: background .15s, color .15s;
  position: relative;
}

.nav-link:hover {
  background: rgba(255,255,255,.07);
  color: #e2e8f0;
}

.nav-link.active {
  background: rgba(37,99,235,.18);
  color: #60a5fa;
  font-weight: 600;
}

.nav-link.active::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 20px;
  background: #3b82f6;
  border-radius: 0 2px 2px 0;
}

.nav-link i {
  font-size: 1.2rem;
  width: 22px;
  text-align: center;
  flex-shrink: 0;
}

.nav-text {
  font-weight: 500;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Section dividers */
.nav-divider {
  list-style: none;
  margin: .75rem .6rem .35rem;
  padding: 0;
}

.nav-section-title {
  display: block;
  font-size: .8rem;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: .07em;
  text-transform: uppercase;
  text-align: center;
  padding: 0 .65rem .3rem;
  border-bottom: 1px solid rgba(255,255,255,.3);
}

/* Restaurant menu group dropdown */
.nav-group-toggle {
  width: 100%;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.nav-group-toggle .nav-chevron {
  margin-left: auto;
  font-size: 0.75rem;
  opacity: 0.85;
}

.nav-guide-item .nav-link {
  border-top: 1px solid rgba(255, 255, 255, 0.12);
  margin-top: 0.25rem;
  padding-top: 0.65rem;
}

.nav-guide-item .nav-link.active,
.nav-guide-item .nav-link:hover {
  background: rgba(255, 255, 255, 0.08);
}

/* Sub-items */
.nav-sub-item .nav-link {
  margin-left: 1.75rem;
  padding-left: .9rem;
  font-size: .87rem;
}

.nav-sub-item .nav-link::after {
  content: '';
  position: absolute;
  left: -.4rem;
  top: 50%;
  width: 2px;
  height: 14px;
  background: rgba(255,255,255,.12);
  transform: translateY(-50%);
}

/* Collapsed sidebar */
.admin-sidebar.collapsed .logo { justify-content: center; }

.admin-sidebar.collapsed .nav-link {
  margin: 0 .3rem;
  padding: .8rem 0;
  justify-content: center;
  border-radius: 8px;
}

.admin-sidebar.collapsed .nav-link:hover { transform: none; }

.admin-sidebar.collapsed .nav-sub-item .nav-link {
  margin-left: .3rem;
}

.admin-sidebar.collapsed .nav-link.active::before {
  left: -3px;
  width: 3px;
  height: 18px;
}

/* ── Main content ───────────────────────────────────────────────────────── */
.admin-main {
  flex: 1;
  margin-left: 260px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: calc(100vw - 260px);
  max-width: calc(100vw - 260px);
  transition: margin-left .28s cubic-bezier(.4,0,.2,1),
              width .28s cubic-bezier(.4,0,.2,1),
              max-width .28s cubic-bezier(.4,0,.2,1);
  overflow-x: hidden;
  position: relative;
}

.admin-main.sidebar-collapsed {
  margin-left: 72px;
  width: calc(100vw - 72px);
  max-width: calc(100vw - 72px);
}

/* ── Top Header ─────────────────────────────────────────────────────────── */
.admin-header {
  background: #0C5A85;
  border-bottom: var(--admin-header-border, 2px) solid #AFC7D6;
  padding: 0;
  position: sticky;
  top: 0;
  z-index: 500;
  width: 100%;
  flex-shrink: 0;
  box-shadow: 0 2px 12px rgba(12,90,133,.3);
  box-sizing: border-box;
}

.header-wrapper { width: 100%; padding: 0 2rem; box-sizing: border-box; }

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: var(--admin-header-h);
  min-height: var(--admin-header-h);
  width: 100%;
  flex-wrap: nowrap;
  overflow: hidden;
  box-sizing: border-box;
}

.header-left {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: .875rem;
}

.page-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #fff;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
  letter-spacing: -.01em;
}

.breadcrumb { margin: 0; }

.breadcrumb-list {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: .35rem;
  font-size: .8rem;
  color: rgba(255,255,255,.55);
}

.breadcrumb-list li:not(:last-child)::after {
  content: '/';
  margin: 0 .35rem;
  color: rgba(255,255,255,.3);
}

.breadcrumb-list a { color: rgba(255,255,255,.65); text-decoration: none; }
.breadcrumb-list a:hover { color: #fff; }

.header-right {
  display: flex;
  align-items: center;
  gap: .75rem;
  flex-shrink: 0;
}

.header-item { position: relative; }

/* Header buttons */
.header-btn {
  display: flex;
  align-items: center;
  gap: .45rem;
  padding: .55rem .9rem;
  background: rgba(255,255,255,.12);
  border: 1.5px solid rgba(255,255,255,.2);
  border-radius: 9px;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  font-size: .875rem;
  font-weight: 500;
  min-height: 38px;
  transition: background .15s, border-color .15s, transform .1s;
  font-family: inherit;
  position: relative;
}

.header-btn:hover {
  background: rgba(255,255,255,.22);
  border-color: rgba(255,255,255,.38);
  transform: translateY(-1px);
}

.header-btn:active { transform: translateY(0); }

.header-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(255,255,255,.2);
}

.user-menu-btn {
  white-space: nowrap;
  overflow: hidden;
  max-width: 200px;
  min-width: 120px;
}

.user-menu-btn .bi-chevron-down { transition: transform .25s ease; }
.user-menu-btn:hover .bi-chevron-down { transform: rotate(180deg); }

/* Notification badge */
.notification-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ef4444;
  color: #fff;
  font-size: .65rem;
  padding: .15rem .4rem;
  border-radius: 10px;
  min-width: 18px;
  text-align: center;
  z-index: 10;
  box-shadow: 0 2px 6px rgba(239,68,68,.4);
  animation: pulse-badge 2s infinite;
}

@keyframes pulse-badge {
  0%   { box-shadow: 0 0 0 0 rgba(239,68,68,.6); }
  70%  { box-shadow: 0 0 0 8px rgba(239,68,68,0); }
  100% { box-shadow: 0 0 0 0 rgba(239,68,68,0); }
}

/* Sidebar toggle */
.sidebar-toggle-btn {
  background: rgba(255,255,255,.12);
  border: 1.5px solid rgba(255,255,255,.2);
  border-radius: 7px;
  font-size: 1.2rem;
  color: #fff;
  padding: .45rem .55rem;
  cursor: pointer;
  transition: background .15s, transform .1s;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: inherit;
}

.sidebar-toggle-btn:hover {
  background: rgba(255,255,255,.22);
  transform: scale(1.04);
}

.sidebar-toggle-btn:active { transform: scale(.96); }

/* Dropdown menus (teleported ones stay portal) */
.user-dropdown-portal,
.notifications-dropdown-portal {
  animation: fadeInDown .2s ease-out;
}

@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-8px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* Notification items */
.notification-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid #f1f5f9;
  cursor: pointer;
  transition: background .15s;
}

.notification-item:hover { background: #f8fafc; }

.view-all-notifications {
  padding: 10px;
  text-align: center;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 0 0 8px 8px;
  cursor: pointer;
  transition: background .15s;
}

.view-all-notifications:hover { background: #f1f5f9; }

/* Dropdown items (in teleport inline styles) shared classes */
.dropdown-item {
  display: flex;
  align-items: center;
  gap: .65rem;
  padding: .65rem 1rem;
  color: #374151;
  text-decoration: none;
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  font-size: .875rem;
  transition: background .15s;
  font-family: inherit;
}

.dropdown-item:hover { background: #f8fafc; }

/* Mobile overlay */
.sidebar-overlay {
  position: fixed;
  inset: 0;
  top: var(--admin-header-total);
  background: rgba(0,0,0,.55);
  z-index: 999;
  backdrop-filter: blur(3px);
}

/* ── Page content ───────────────────────────────────────────────────────── */
.admin-content {
  flex: 1;
  padding: 2rem;
  overflow-y: auto;
  background: #f8fafc;
  min-height: calc(100vh - var(--admin-header-h, 68px));
  width: 100%;
  scrollbar-width: thin;
  scrollbar-color: #e2e8f0 transparent;
}

.admin-content.admin-content--home-builder {
  padding: 0;
  overflow: hidden;
  min-height: 0;
  height: calc(100vh - var(--admin-header-total));
  display: flex;
  flex-direction: column;
}

.admin-content::-webkit-scrollbar { width: 5px; }
.admin-content::-webkit-scrollbar-track { background: transparent; }
.admin-content::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 3px; }

/* ── Responsive ─────────────────────────────────────────────────────────── */
@media (max-width: 992px) {
  .admin-content { padding: 1.75rem; }
  .header-wrapper { padding: 0 1.5rem; }
  .user-menu-btn { max-width: 150px; min-width: 100px; }
}

@media (max-width: 768px) {
  .admin-header {
    /* match sidebar so no light strip/gap under the navbar */
    border-bottom-color: #0f172a;
  }

  .admin-sidebar {
    transform: translateX(-100%);
    transition: transform .28s cubic-bezier(.4,0,.2,1);
    z-index: 1001;
    width: 260px;
    max-width: 85vw;
    top: var(--admin-header-total);
    height: calc(100vh - var(--admin-header-total));
    height: calc(100dvh - var(--admin-header-total));
    overflow-x: hidden;
    touch-action: pan-y;
  }

  .admin-sidebar:not(.collapsed) { transform: translateX(0); }

  .admin-sidebar .sidebar-nav {
    overflow-x: hidden;
    touch-action: pan-y;
  }

  .admin-main,
  .admin-main.sidebar-collapsed {
    margin-left: 0;
    width: 100vw;
    max-width: 100vw;
  }

  .admin-header { z-index: 1002; }
  .admin-content { padding: 1.25rem; }
  .header-wrapper { padding: 0 1rem; }

  .page-title {
    font-size: 1.1rem;
    max-width: 160px;
  }
}

@media (max-width: 576px) {
  .admin-layout { --admin-header-h: 58px; }
  .header-wrapper { padding: 0 .75rem; }
  .admin-content { padding: 1rem; min-height: calc(100vh - var(--admin-header-total)); }
  .admin-content.admin-content--home-builder {
    height: calc(100vh - var(--admin-header-total));
  }
  .page-title { font-size: 1rem; max-width: 120px; }
  .header-right { gap: .35rem; }
  .header-btn { padding: .45rem .65rem; font-size: .8rem; min-height: 34px; }
  .user-name { display: none; }
  .user-menu-btn { min-width: auto; max-width: none; padding: .45rem .65rem; }
  .breadcrumb { display: none; }
  .nav-link { margin: 0 .4rem; padding: .75rem .9rem; font-size: .8rem; }
  .sidebar-header { padding: .875rem .75rem; min-height: 58px; }
}

@media (max-width: 480px) {
  .admin-layout { --admin-header-h: 54px; }
  .admin-content { padding: .75rem; }
  .page-title { font-size: .95rem; }
  .header-wrapper { padding: 0 .5rem; }
  .header-btn { padding: .375rem .5rem; min-height: 30px; }
}
</style>

